import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {MultishareHistoryFilterModel} from './multishare-history-table/multishare-history-table.component';

@Component({
  selector: 'app-multishare-history',
  template: `
    <div class="multishare-history-wrapper">
      <div class="multishare-history-search-wrapper">
        <app-multishare-history-search (searchForm)="handleSearchForm($event)"></app-multishare-history-search>
      </div>
      <app-multishare-history-table [searchFormValues]="searchFormValues"></app-multishare-history-table>
    </div>
  `,
  styleUrls: ['./multishare-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultishareHistoryComponent implements OnInit {
  searchFormValues: MultishareHistoryFilterModel | undefined;

  constructor() {
  }

  ngOnInit(): void {
  }

  handleSearchForm($event: MultishareHistoryFilterModel) {
    this.searchFormValues = $event;
  }
}
